interface ApiFailure {
  response?: { status?: number; data?: { message?: unknown } };
}

/** What Nest answers when a role guard refuses: generic, and in English. */
const GUARD_DEFAULT_MESSAGE = 'Forbidden resource';

/**
 * The reason the backend gives for a refusal (403), written in Polish, such as
 * a visit past its edit window. Other failures stay with the caller's own
 * translated message: their backend text may be English or technical.
 */
export function forbiddenMessage(error: unknown): string | undefined {
  const response = (error as ApiFailure | undefined)?.response;
  const message = response?.data?.message;
  return response?.status === 403 &&
    typeof message === 'string' &&
    message !== GUARD_DEFAULT_MESSAGE
    ? message
    : undefined;
}
